import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';

export const UPITNIK_ODGOVOR_STATUSI = ['NOVO', 'PRIHVACENO', 'ODBIJENO', 'DUPLIKAT'] as const;
export type UpitnikOdgovorStatus = (typeof UPITNIK_ODGOVOR_STATUSI)[number];

export const upitnikOdgovorStatusItems = {
  labels: UPITNIK_ODGOVOR_STATUSI.map((s) => `groblja:upitnik_odgovori.statusi.${s.toLowerCase()}`),
  values: [...UPITNIK_ODGOVOR_STATUSI],
  chipColors: ['info', 'success', 'default', 'warning'],
};

const UpitnikOdgovori: IModel = {
  title: 'Upitnici - odgovori',
  apiPath: 'groblja/upitnici/odgovori',
  layer: 'grobna_mjesta',
  forms: {},
  listViews: {
    default: {
      fields: [
        'id',
        'created_on',
        'status',
        'groblje_id',
        'odjel',
        'polje',
        'red',
        'broj',
        'ime',
        'prezime',
        'oib',
        'kontakt',
        'adresa',
        'napomena',
        'broj_privitaka',
        'ima_obveznika',
        'obradio',
        'obradjeno_on',
      ],
      hidden: ['id', 'obradio', 'obradjeno_on'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'created_on',
      source: 'created_on',
      ttoken: 'groblja:upitnik_odgovori.created_on',
      type: 'datetime',
      filter: true,
      readonly: true,
    },
    {
      title: 'status',
      source: 'status',
      ttoken: 'groblja:upitnik_odgovori.status',
      type: 'picker',
      items: upitnikOdgovorStatusItems,
      filter: true,
      translate: true,
      readonly: true,
    },
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
    },
    {
      title: 'odjel',
      source: 'odjel',
      ttoken: 'groblja:grobna_mjesta.odjel',
      type: 'text',
      filter: true,
    },
    {
      title: 'polje',
      source: 'polje',
      ttoken: 'groblja:grobna_mjesta.polje',
      type: 'text',
      filter: true,
    },
    {
      title: 'red',
      source: 'red',
      ttoken: 'groblja:grobna_mjesta.red',
      type: 'text',
      filter: true,
    },
    {
      title: 'broj',
      source: 'broj',
      ttoken: 'groblja:grobna_mjesta.broj',
      type: 'text',
      filter: true,
    },
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'groblja:upitnik.ime',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'groblja:upitnik.prezime',
      type: 'text',
      filter: true,
    },
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'groblja:upitnik.oib',
      type: 'text',
      filter: true,
    },
    {
      title: 'kontakt',
      source: 'kontakt',
      ttoken: 'groblja:upitnik.kontakt',
      type: 'text',
      filter: true,
    },
    {
      title: 'adresa',
      source: 'adresa',
      ttoken: 'groblja:upitnik_odgovori.adresa',
      type: 'text',
      filter: true,
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'groblja:upitnik.napomena',
      type: 'text',
      filter: true,
    },
    {
      title: 'broj_privitaka',
      source: 'broj_privitaka',
      ttoken: 'groblja:upitnik_odgovori.broj_privitaka',
      type: 'wholenum',
      filter: true,
      readonly: true,
    },
    {
      title: 'ima_obveznika',
      source: 'ima_obveznika',
      ttoken: 'groblja:upitnici.ima_obveznika',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'obradio',
      source: 'obradio',
      ttoken: 'groblja:upitnik_odgovori.obradio',
      type: 'text',
      filter: true,
      readonly: true,
    },
    {
      title: 'obradjeno_on',
      source: 'obradjeno_on',
      ttoken: 'groblja:upitnik_odgovori.obradjeno_on',
      type: 'datetime',
      filter: true,
      readonly: true,
    },
    // not shown, but DataController drops keys without a field and the detail dialog and map need them
    {
      title: 'grobno_mjesto_id',
      source: 'grobno_mjesto_id',
      ttoken: '',
      type: 'wholenum',
      readonly: true,
    },
    {
      title: 'groblje_naziv',
      source: 'groblje_naziv',
      ttoken: 'groblja:upitnici.groblje',
      type: 'text',
      readonly: true,
    },
    {
      title: 'ulica',
      source: 'ulica',
      ttoken: 'groblja:upitnik.ulica',
      type: 'text',
      readonly: true,
    },
    {
      title: 'mjesto',
      source: 'mjesto',
      ttoken: 'groblja:upitnik.mjesto',
      type: 'text',
      readonly: true,
    },
    {
      title: 'ptt',
      source: 'ptt',
      ttoken: 'groblja:upitnik.ptt',
      type: 'wholenum',
      readonly: true,
    },
    {
      title: 'drzava',
      source: 'drzava',
      ttoken: 'groblja:upitnik.drzava',
      type: 'text',
      readonly: true,
    },
    coreFields.geom,
  ],
};

export default UpitnikOdgovori;
